
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class ProgressbarInfo extends Vue {
  @Prop({ default: '' }) title!: string;
  @Prop({ default: 0 }) percentage?: number;
}
